import React, { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import Button from "../../Button";
import InputDropdown from "../../CommonComponents/InputDropdown";
import Badge from "../../CommonComponents/Badge";

const TopicComplexity = ({
  topicOptions = [],
  complexityOptions = [],
  topicComplexity = [],
  onAddTopicComp = null,
  onRemoveTopicComp = null,
  errors,
  topicId=null
}) => {
  const [topic, setTopic] = useState(null);
  const [complexity, setComplexity] = useState(null);

  useEffect(()=>{
    setTopic(topicId);
  },[topicOptions]);

  const onAddTopicComplexity = () => {
    if (onAddTopicComp) {
      onAddTopicComp(topic, complexity);
    }
    setTopic(null);
    setComplexity(null);
  };

  const onRemoveTopicComplexity = (id) => {
    if (onRemoveTopicComp) {
      onRemoveTopicComp(id);
    }
  };

  return (
    <div className="topic-complexity-container">
      <div className={errors.topicComplexity ? "topic-complexity-input-error" : "topic-complexity-input"}>
        {/* <InputDropdown
          label="Subject"
          placeholder="Select subject"
          creatable
          searchable
          value={topic}
          options={topicOptions}
          onChange={(value) => setTopic(value)}
          hintText={errors.topicComplexity}
          destructive={!!errors.topicComplexity}
        /> */}
        <InputDropdown
          label="Topic"
          placeholder="Select topic"
          creatable={true}
          searchable
          value={topic}
          options={topicOptions}
          onChange={(value) => setTopic(value)}
          hintText={errors.topicComplexity}
          destructive={!!errors.topicComplexity}
        />
        <InputDropdown
          label="Complexity"
          placeholder="Select complexity"
          value={complexity}
          options={complexityOptions}
          onChange={(value) => setComplexity(value)}
          hintText={errors.topicComplexity}
          destructive={!!errors.topicComplexity}
        />
        <Button
          size="lg"
          hierarchy={{
            type: "secondaryGrey",
            buttonText: "Topic",
          }}
          onClick={onAddTopicComplexity}
          icon={{
            icon: (
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.66927 0.834961V12.5016M0.835938 6.66829H12.5026"
                  stroke="#D0D5DD"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ),
            type: "leading",
          }}
          className={errors.topicComplexity ? "input-error-button":""}
          disable={!topic || !complexity}
        />
      </div>
      <div className="topic-complexity-badges">
        {topicComplexity?.map((topic) => (
          <div
            className="topic-complexity-badges-list"
            key={topic.id ?? nanoid()}
          >
            <div className="topic-complexity-badges-list-items">
              <Badge
                size="lg"
                color="grey"
                className="topic-complexity-badge-item"
                label={
                  <>
                    <div className="topic-complexity-badge-item-icon-container">
                      <Badge label={topic.topicName} />
                      <svg
                        className="topic-complexity-badge-item-icon"
                        width="20"
                        height="16"
                        viewBox="0 0 20 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.2"
                          y="0.2"
                          width="19.6"
                          height="15.6"
                          rx="7.8"
                          fill="white"
                        />
                        <rect
                          x="0.2"
                          y="0.2"
                          width="19.6"
                          height="15.6"
                          rx="7.8"
                          stroke="#667085"
                          strokeWidth="0.4"
                        />
                        <path
                          d="M7.75 5.5H7.5C6.11929 5.5 5 6.61929 5 8C5 9.38071 6.11929 10.5 7.5 10.5H8.5C9.88071 10.5 11 9.38071 11 8M12.25 10.5H12.5C13.8807 10.5 15 9.38071 15 8C15 6.61929 13.8807 5.5 12.5 5.5H11.5C10.1193 5.5 9 6.61929 9 8"
                          stroke="#344054"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <Badge
                      label={topic.complexityName}
                      color="success"
                      className={topic.complexityName?.toLowerCase() ?? ""}
                    />
                  </>
                }
              />
            </div>
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => onRemoveTopicComplexity(topic.id)}
            >
              <path
                d="M0.800781 3.46647H2.13411M2.13411 3.46647H12.8008M2.13411 3.46647V12.7998C2.13411 13.1534 2.27459 13.4926 2.52464 13.7426C2.77469 13.9927 3.11383 14.1331 3.46745 14.1331H10.1341C10.4877 14.1331 10.8269 13.9927 11.0769 13.7426C11.327 13.4926 11.4674 13.1534 11.4674 12.7998V3.46647H2.13411ZM4.13411 3.46647V2.13314C4.13411 1.77952 4.27459 1.44038 4.52464 1.19033C4.77469 0.94028 5.11383 0.799805 5.46745 0.799805H8.13411C8.48774 0.799805 8.82688 0.94028 9.07692 1.19033C9.32697 1.44038 9.46745 1.77952 9.46745 2.13314V3.46647M5.46745 6.7998V10.7998M8.13411 6.7998V10.7998"
                stroke="#F04438"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopicComplexity;
